import { type ComponentProps, memo } from "react";

import CompanyDomainsCell from "../../../components/cells/CompanyDomainsCell/CompanyDomainsCell";
import { useExpandableRow } from "../../../hooks/cells/useExpandableRow";
import type { BaseTableRow, TableRecord } from "../../../types";
import type { ExpandedRowVariant } from "../../../types/expanded-row";

const DOMAINS_VARIANT: ExpandedRowVariant = { kind: "domains" };

type Props<RecordType extends BaseTableRow> = Pick<ComponentProps<typeof CompanyDomainsCell>, "value"> & {
    record: TableRecord<RecordType>;
};

const CompanyDomainsCellContainer = <_, RecordType extends BaseTableRow>({ value, record }: Props<RecordType>) => {
    const { isExpanded, onToggle } = useExpandableRow(record.key, DOMAINS_VARIANT);

    return (
        <CompanyDomainsCell
            value={value}
            onExpand={onToggle}
            isExpanded={isExpanded}
        />
    );
};

export default memo(CompanyDomainsCellContainer);
